import $ from 'jquery';

$(document).ready(function () {
    const ib_spinner = function () {
        // eslint-disable-next-line no-undef
        if ('false' === ideabox_object.wc_active) {
            return;
        }

        $('input.qty[type="number"]').inputSpinner({
            groupClass: 'ib-flex ib-spinner-group',
            buttonsClass: 'btn-spinner',
            buttonsWidth: '1.75rem',
        });
    };

    ib_spinner();

    $(document.body).on('updated_wc_div', function () {
        ib_spinner();
    });
});
